import React from "react";
import { connect } from "react-redux";
import CorreoOlvideContrasenia from "./correoOlvideContrasenia.cmpt";
import OpcionesOlvideContrasenia from "./opcionesOlvideContrasenia.cmpt"
import "./estilos_olv.css";

const mapState = (state) => {
    return {
        paso: state.olvideContrasenia.paso,
    };
};

const mapDispatch = () => {
    return {};
};

class Flujo extends React.Component {

    render() {
        return (
            <div>
                {this.props.paso === 0 &&
                    <OpcionesOlvideContrasenia />
                }
                {this.props.paso === 1 &&
                    <CorreoOlvideContrasenia />
                }
            </div>
        );
    }
}

export default connect(mapState, mapDispatch)(Flujo);



// WEBPACK FOOTER //
// ./src/gnp-olvide-contrasenia/flujo.cmpt.js